import { JsonUtils } from '../../utils/json.util'
import { ResponseAge } from './active.search.by.groupAge'
import { ResponseMammogram } from './active.search.by.mammogram'
import { ResponseYesNo } from './active.search.by.response'

export class ActiveSearchResponse {

    private _total_forms: number | undefined
    private _breast_change: ResponseYesNo | undefined
    private _has_lump: ResponseYesNo | undefined
    private _spontaneous_nipple_discharge: ResponseYesNo | undefined
    private _breast_cancer_diagnosed: ResponseYesNo | undefined
    private _had_mammogram: ResponseYesNo | undefined
    private _last_mammogram_date: ResponseMammogram | undefined
    private _family_history: any | undefined
    private _age_group: any | undefined

    get total_forms(): number | undefined {
        return this._total_forms
    }
    set total_forms(value: number | undefined) {
        this._total_forms = value
    }

    get breast_change(): ResponseYesNo | undefined {
        return this._breast_change
    }
    set breast_change(value: ResponseYesNo | undefined) {
        this._breast_change = value
    }
    get has_lump(): ResponseYesNo | undefined {
        return this._has_lump
    }
    set has_lump(value: ResponseYesNo | undefined) {
        this._has_lump = value
    }
    get spontaneous_nipple_discharge(): ResponseYesNo | undefined {
        return this._spontaneous_nipple_discharge
    }
    set spontaneous_nipple_discharge(value: ResponseYesNo | undefined) {
        this._spontaneous_nipple_discharge = value
    }
    get breast_cancer_diagnosed(): ResponseYesNo | undefined {
        return this._breast_cancer_diagnosed
    }
    set breast_cancer_diagnosed(value: ResponseYesNo | undefined) {
        this._breast_cancer_diagnosed = value
    }
    get had_mammogram(): ResponseYesNo | undefined {
        return this._had_mammogram
    }
    set had_mammogram(value: ResponseYesNo | undefined) {
        this._had_mammogram = value
    }
    get last_mammogram_date(): ResponseMammogram | undefined {
        return this._last_mammogram_date
    }
    set last_mammogram_date(value: ResponseMammogram | undefined) {
        this._last_mammogram_date = value
    }
    get age_group(): ResponseAge | undefined {
        return this._age_group
    }
    set age_group(value: ResponseAge | undefined) {
        this._age_group = value
    }
    public fromJSON(json: any): ActiveSearchResponse {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }


        if (json.total_forms !== undefined) {
            this.total_forms = json.total_forms
        }
        if (json.breast_change !== undefined) {
            this.breast_change = new ResponseYesNo().fromJSON(json.breast_change)
        }
        if (json.has_lump !== undefined) {
            this.has_lump = new ResponseYesNo().fromJSON(json.has_lump)
        }
        if (json.spontaneous_nipple_discharge !== undefined) {
            this.spontaneous_nipple_discharge = new ResponseYesNo().fromJSON(json.spontaneous_nipple_discharge)
        }
        if (json.breast_cancer_diagnosed !== undefined) {
            this.breast_cancer_diagnosed = new ResponseYesNo().fromJSON(json.breast_cancer_diagnosed)
        }
        if(json.had_mammogram!==undefined){
            this.had_mammogram = new ResponseYesNo().fromJSON(json.had_mammogram)
        }
        if(json.last_mammogram_date!==undefined){
            this.last_mammogram_date = new ResponseMammogram().fromJSON(json.last_mammogram_date)
        }
        if(json.age_group !== undefined){
            this.age_group = new ResponseAge().fromJSON(json.age_group)
        }
        return this
    }
    public toJSON(): any {
        return {
            total_forms: this.total_forms || undefined,
            breast_change: this.breast_change || undefined,
            has_lump: this.has_lump || undefined,
            spontaneous_nipple_discharge: this.spontaneous_nipple_discharge || undefined,
            breast_cancer_diagnosed: this.breast_cancer_diagnosed || undefined,
            had_mammogram:this.had_mammogram || undefined,
            last_mammogram_date: this.last_mammogram_date || undefined,
            age_group: this.age_group || undefined
        }
    }
}